// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "monaco-editor" + "." + "8f56583b" + ".css";
};